<template>
  <BaseTableView
    :head="userType !== 'subscriber'
      ? edit
        ? tableHead.concat({text: '', active: true})
        : tableHead
      : tableHeadSubscriber"
    :sticky="sticky"
  >
    <template v-for="(item, key) in items">
      <ProjectMaterialsAndPricesTableItem
        v-if="
          navigationGuardianChangeData &&
          navigationGuardianChangeData.workClientProjectsWorkTypeAll_project ?
          navigationGuardianChangeData.workClientProjectsWorkTypeAll_project[key] !== 'delete' : true
        "
        :key="'item_' + $route.params.id + '_' + item.id"
        :itemKey="key"
        :item="item"
        :client="false"
        :workTypeList="workTypeList"
        :edit="edit"
        @editing="onEditing"
        :table-min="$vuetify.breakpoint.lgAndDown"
      />
    </template>
    <ProjectMaterialsAndPricesTableItem
      v-for="(item, key) in itemsDefault"
      :key="'default_' + 'item_' + $route.params.id + '_' + key"
      :itemKey="key"
      :item="item"
      :client="true"
      :workTypeList="workTypeList"
      :edit="edit"
      @editing="onEditingDefault"
      :table-min="$vuetify.breakpoint.lgAndDown"
    />
  </BaseTableView>
</template>

<script>
import ProjectMaterialsAndPricesTableItem
  from 'components/project/materialsAndPrices/ProjectMaterialsAndPricesTableItem'
import {mapGetters, mapState} from 'vuex'
import BaseTableView from "components/base/tableview/BaseTableView";

export default {
  name: 'ProjectMaterialsAndPricesTable',
  props: ['items', 'itemsDefault', 'workTypeList', 'edit', 'sticky'],
  components: {BaseTableView, ProjectMaterialsAndPricesTableItem},
  data() {
    return {
      tableMin: false,
    }
  },
  computed: {
    ...mapGetters('user', ['userType']),
    ...mapState('navigationGuardian', ['navigationGuardianChangeData']),
    t() {
      return this.localStorage.translations.pages['sales_project']['material_price-tables']
    },
    tableHead() {
      return [
        {text: this.t['kategoriya-rabot']},
        {text: this.t['vid-rabot']},
        {text: this.t['tip-rabot']},
        {text: this.t['obem']},
        {text: this.t['edinitsa-izmereniya']},
        {text: this.t['tsena']},
        {text: this.t['kolichestvo-chasov']},
        {text: "Fixed salary"},
        {text: this.t['summa']},
      ]
    },
    tableHeadSubscriber() {
      return [
        {text: this.t['kategoriya-rabot']},
        {text: this.t['vid-rabot']},
        {text: this.t['tip-rabot']},
        {text: this.t['obem']},
        {text: this.t['edinitsa-izmereniya']},
        {text: this.t['kolichestvo-chasov']},
      ]
    },
  },
  methods: {
    onMin(value) {
      this.tableMin = value
    },
    onEditing(value) {
      value.name = 'workClientProjectsWorkTypeAll_project'
      this.$emit('editing', value)
    },
    onEditingDefault(value) {
      value.name = 'workClientProjectsWorkTypeDefault'
      this.$emit('editing', value)
    },
  },
  watch: {},
}
</script>
